{
  "accessibility": {
    "clear-search": "Clear search",
    "close": "Close",
    "loading": "Loading",
    "qty": {
      "decrease": "Decrease quantity",
      "increase": "Increase quantity",
      "label": "Quantity"
    }
  },
  "account": {
    "header": {
      "logout": "Log out",
      "title": "My Account",
      "who": "Signed in as {email}."
    },
    "main": {
      "address-book": {
        "default-billing": "default billing address",
        "default-shipping": "default shipping address",
        "delete": "Delete Address",
        "disabled-default-billing": "Please note, your billing address cannot be edited. Please speak to our team if you need to make changes",
        "edit": "Edit Address",
        "form": {
          "city": "City",
          "company": "Company",
          "country": "Country",
          "default": "Set as {type}",
          "first-name": "First Name",
          "last-name": "Last Name",
          "line1": "Line 1",
          "line2": "Line 2",
          "phone": "Phone",
          "postal-code": "Zip Code",
          "region": "State",
          "enter-manually": "Enter address manually",
          "find-address": "Find address",
          "lookup-details-error": "Unable to retrieve address details",
          "lookup-no-results": "Sorry, no results were found for this search term.",
          "lookup-placeholder": "Start typing your address...",
          "lookup-suggestions-error": "Unable to fetch address suggestions",
          "lookup-too-many-requests": "Too many requests. Please wait a moment and try again."
        },
        "form-cancel": "Cancel",
        "form-save": "Save address",
        "form-title": {
          "modify": "Modify address",
          "new": "Add new address"
        },
        "header": "Address Book",
        "new": "Add new address",
        "no-addresses": "Your saved addresses will appear here once you've added one.",
        "other": "Other Addresses"
      },
      "company-users": {
        "child-account-notice": "Any activity will be shared across all users from your company including orders, shopping lists, and addresses. Please speak to your company account owner if you have any queries.",
        "delete-confirm-message": "Are you sure you want to remove this user from your company?",
        "delete-failed-message": "Failed to delete user.",
        "email": "Email",
        "header": "Company Users",
        "invite-button-text": "Invite new user",
        "invite-user": {
          "form": {
            "cancel": "Cancel",
            "description": "If the user you're inviting doesn't already have an account to login to your store, they'll receive an \"Account Activation\" email and they'll be asked to set a password to gain access. If they already have an account, they can login with their existing details by visiting the login page. If you're unsure about inviting users, please speak to your contact within our company.",
            "description-bigcommerce": "The user you invite will need to navigate to your store's login page and click \"Forgot your password?\" After entering their email address, they will receive an email for them to set up a password. If you're unsure about inviting users, please speak to your contact within our company.",
            "disclaimer": "When you invite company users, any activity will be shared across your team including orders, shopping lists, and addresses.",
            "email": "Email",
            "email-disabled-title": "Please note you cannot edit a company user's email address",
            "first-name": "First Name",
            "last-name": "Last Name",
            "send-invite": "Create Company User",
            "update-user": "Update Company User",
            "user-role": {
              "header": "User role",
              "limited-customer": {
                "description": "Users will be able to add items to an order but not complete orders. All orders will be sent to the company account owner for approval",
                "header": "Limited"
              },
              "main": {
                "description": "This will allow users to place orders and view all account activity within your shared company account",
                "header": "Standard"
              }
            }
          },
          "header": "Invite new user",
          "invite-failed": "Sorry, it looks like we're not able to invite this user to your company.",
          "invite-sent": "User invite sent"
        },
        "loading-failed-message": "Sorry, it looks like we're not able to load users for your company. Please try again in a moment",
        "name": "Name",
        "no-users": "Share activity across your team including orders, shopping lists, and addresses.",
        "role": {
          "header": "Role",
          "limited-customer": "Limited",
          "main": "Standard"
        },
        "title": "You're signed into a company user account",
        "update-user": {
          "update-failed": "Sorry, it looks like we're not able to update this user.",
          "update-success": "Successfully updated user"
        },
        "your-contact": "(Your company account owner is {contactName})"
      },
      "financials": {
        "header": "Financials",
        "label": {
          "balance": "Unpaid Balance",
          "credit-limit": "Credit Limit",
          "net-terms": "Payment terms"
        },
        "net-terms-type": {
          "10_days": "10 days",
          "15_days": "15 days",
          "30_days": "30 days",
          "45_days": "45 days",
          "60_days": "60 days",
          "7_days": "7 days",
          "90_days": "90 days"
        },
        "sub-text": "Payments may take some time to be updated. Please contact us to discuss payments or credit."
      },
      "my-details": {
        "company": "Company",
        "email": "Email address",
        "header": "My Details",
        "name": "Name",
        "payment-on-account": {
          "detail": "Your account balance is {balance} with a credit limit of {creditLimit}.",
          "detail-without-limit": "Your account balance is {balance}.",
          "header": "Financials",
          "net-terms": "Your payment terms are {type}.",
          "net-terms-type": {
            "10_days": "10 days",
            "15_days": "15 days",
            "30_days": "30 days",
            "45_days": "45 days",
            "60_days": "60 days",
            "7_days": "7 days",
            "90_days": "90 days"
          },
          "sub-text": "Payments may take some time to be updated. Please contact us to discuss payments or credit."
        }
      },
      "recent-orders": {
        "header": "Recent Activity"
      },
      "reports": {
        "by-month": "By month",
        "by-quarter": "By quarter",
        "by-week": "By week",
        "current": "Current",
        "header": "Reports",
        "list-table": {
          "name": "Name"
        },
        "no-results": "There is currently no data to display. Reports will show once you place your first order.",
        "type": {
          "purchase-history": {
            "name": "Purchase history by time period",
            "table": {
              "product": "Product"
            }
          }
        }
      }
    },
    "shopping-list": {
      "add-to-cart": "Add items to…",
      "cancel": "Cancel",
      "created-on": "Created on {date} at {time}",
      "delete-confirm": "Are you sure you want to delete this shopping list?",
      "done": "Done",
      "edit-bulk-actions": "Edit & bulk actions",
      "empty-message": "Add products using the search above to start building your list.",
      "empty-title": "This list is empty",
      "last-modified": "Last modified on {date} at {time}",
      "remove": "Remove",
      "rename": "Rename",
      "save": "Save",
      "save-cart": {
        "title": "Save cart as shopping list",
        "notes": "You can save this cart as a shopping list, making it easy to re-order the same items again in the future",
        "placeholder": "Enter list name"
      },
      "selected-count": "{selected} of {total} selected",
      "custom-attributes-excluded": "{count} {count, plural, =1 {product was not added as it has} other {products were not added as they have}} custom options."
    },
    "shopping-lists": {
      "date": "Last Updated",
      "date-short": "Updated",
      "delete": "Delete",
      "empty": "Your shopping lists will appear here once you've added one.",
      "header": "Shopping Lists",
      "load": "Load",
      "name": "Name",
      "no-results": "No shopping lists match your search.",
      "search": "Search by name",
      "export": "Export as CSV",
      "create": {
        "button": "Create List",
        "title": "Create a shopping list",
        "input": "Shopping list title"
      },
      "add-to-shopping-list": {
        "title": "Add to shopping list",
        "create-list": "Or create a new shopping list",
        "empty-state": {
          "title": "Create your first list",
          "message": "Save this product to a new shopping list so you can re-order it later."
        }
      }
    },
    "order-actions": {
      "cancel": "Cancel Order",
      "cancel-confirm": "Are you sure you want to cancel this order?",
      "cancel-quote-confirm": "Are you sure you want to cancel this quote? This will archive it but you can still access it from your account.",
      "complete": "Review & Complete Order",
      "load-confirm": "You are already editing a {currentPurchaseType}, by continuing you will lose your changes"
    },
    "order-list": {
      "amount": "Amount",
      "aria-package-id": "Package ID",
      "custom-date-range": "Custom Date Range",
      "customer": "Customer",
      "date": "Submitted on",
      "date-range-error": "Date range must be between 0 and 365 days",
      "empty": "Your order activity will show here when you place your first order.",
      "empty-date-range": "Nothing found in the selected date range",
      "end-date": "End Date",
      "filtered-empty": "No results for the selected date range or search query.",
      "id": "#",
      "loading": "Loading...",
      "order": "Order",
      "order-placed-year": "Orders placed in",
      "package-update": "Updated on",
      "purchase": {
        "line-item": {
          "price-poa": "POA"
        }
      },
      "reference": "Reference",
      "start-date": "Start Date",
      "status": "Status",
      "shipped-by": "Shipped by",
      "track-shipment": "Track shipment",
      "view": "View"
    },
    "order-purchase-status": {
      "paid": "Paid",
      "part_paid": "Part paid",
      "unpaid": "Unpaid"
    },
    "order-status": {
      "archived": "Archived",
      "awaiting_approval": "Requires approval",
      "awaiting_merchant": "Awaiting merchant",
      "cancelled": "Cancelled",
      "complete": "Complete",
      "incoming": "Incoming",
      "part_returned": "Part-returned",
      "part_shipped": "Part-shipped",
      "processing": "Processing",
      "quote": "Quote Requested",
      "returned": "Returned",
      "shipped": "Shipped",
      "varied": "Varied"
    },
    "order-type": {
      "all": "All",
      "archived": "Archived",
      "awaiting_approval": "Requires approval",
      "awaiting_merchant": "Awaiting merchant",
      "order": "Order",
      "quote": "Quote"
    },
    "order-view": {
      "balance-due": "Due",
      "cancel-and-archive": "Cancel and archive.",
      "confirm-and-complete": "Confirm & Complete",
      "custom-date-range": "Custom Date Range",
      "date-range-error": "Date range must be between 0 and 365 days",
      "edit-quote": "Edit Quote",
      "end-date": "End Date",
      "file-attachment": {
        "assignment": "Assignment",
        "download": "Download",
        "file-name": "File Name",
        "header": "Attachments",
        "order-level": "Order-level",
        "processing": "File still processing, please refresh"
      },
      "header": {
        "additional-information": "Additional Information",
        "attachments": "Attachments",
        "customer-reference": "Customer Ref.",
        "my-account": "My Account",
        "my-customers": "My Customers",
        "order-details": "Purchase",
        "order-history": "Activity",
        "order-lines": "Order Lines",
        "order-reference": "Order Ref.",
        "payment-method": "Payment Method",
        "payment-status": "Payment Status",
        "placed-on": "Placed on",
        "shipping-address": "Shipping Address",
        "shipping-method": "Shipping Method",
        "status": "Status",
        "submitted-by": "Submitted by",
        "submitted-on": "Submitted on",
        "summary": "Summary",
        "timeline": "Timeline"
      },
      "invoice": "View & Download Invoice",
      "order-lines": {
        "collapse": "Minimise order lines",
        "expand": "View all order lines ({count} in total)"
      },
      "order-review": {
        "description": "Please note, your account has been setup to require approval before any orders can be placed. Please click the \"Submit Order\" button below to continue",
        "title": "This order needs to be reviewed"
      },
      "payment-methods": {
        "other": "Other",
        "paymentByInvoice": "On Invoice",
        "paymentOnAccount": "On Account",
        "quote": "Quote",
        "upfrontPayment": "Card Payment"
      },
      "quote": "View & Download Quote",
      "quote-not-required": "No longer require this quote?",
      "redirect-to-checkout": "You'll be redirected to the checkout to edit or complete your order.",
      "refund-discrepancy-msg": "There's a refund discrepancy on this package of",
      "search": {
        "label": "Search",
        "placeholder": "Search orders by ID, PO number or address"
      },
      "see-fewer-fields": "See less",
      "see-more-fields": "See more…",
      "start-date": "Start Date"
    },
    "orders-list": {
      "header": "Activity",
      "download": "Download",
      "export-activity": "Activity",
      "export-activity-line-items": "Activity with line items"
    },
    "purchase-history": {
      "agent-role": "Sales Team",
      "customer-role": "Customer",
      "expire": {
        "quote-expired": "The quote has expired"
      },
      "message": {
        "create": {
          "button-message": "Send as Email",
          "button-note": "Save Note",
          "internal-note-info": "Notes are only visible to sales agents who have access to view the customers' purchase/quote.",
          "message-to-customer-info": "Notifying a customer will send them an email. They'll need to login to their account to reply.",
          "note-option": "Save as internal note",
          "notify-option": "Notify customer",
          "placeholder": "Enter a message here"
        },
        "message-sent": "sent a message",
        "note-added": "added a note",
        "email-reply": "replied via email"
      },
      "title": "Timeline",
      "transaction": {
        "payment-message": {
          "payment": "{amount} paid against order",
          "refund": "{amount} refunded against order"
        },
        "title": {
          "payment": "Payment",
          "refund": "Refund"
        },
        "transaction-date": "Transaction made on {date}"
      },
      "update": {
        "assignee-change": {
          "body": "Reassigned from {previous} to {new}",
          "body-new-assignee": "{new} was assigned",
          "body-no-assignee": "{previous} was unassigned",
          "heading": "Assignee updated"
        },
        "expiry-change": {
          "body": "Expiry changed from {previous} to {new}",
          "body-new-expiry": "Expiry date set to {new}",
          "body-no-expiry": "Expiry date of {previous} has been removed",
          "heading": "Expiry date updated"
        },
        "number-of-updates": "{numberOf} {numberOf, plural, =1 {update made} other {updates made}}",
        "quote-updated": "updated the quote",
        "status-change": {
          "body": "Status changed from {previous} to {new}",
          "heading": "Status updated"
        },
        "view": "View updates"
      }
    },
    "quote": {
      "details": {
        "assignee": "Assignee",
        "badge": "Additional Quote Details",
        "edit": {
          "assignee": {
            "label": "Assigned Sales Agent",
            "no-assignee": "No assignee",
            "select-agent": "Select an agent"
          },
          "cancel": "Cancel",
          "expiry-warning-message": "Changing status from {status} requires setting an expiry date",
          "expiry-warning-title": "Expiry required",
          "save": "Save"
        },
        "expiry": {
          "after-date": "After this date, the customer will need to start a new quote.",
          "edit-details": "Edit quote details",
          "label": "Expiry Date",
          "label-expired": "Expired",
          "label-in-days": "In {days} {days, plural, =1 {day} other {days}}",
          "label-in-hours": "In {hours} {hours, plural, =1 {hour} other {hours}}",
          "label-no-expiry": "No expiry"
        },
        "no-assignee": "No assignee",
        "requested-on": "Requested on",
        "status": "Quote Status",
        "status-options": {
          "awaiting-customer": "Awaiting Customer",
          "awaiting-merchant": "Awaiting Merchant",
          "quote-requested": "Quote Requested"
        }
      }
    },
    "sales-agent": {
      "header": "Sales Agent Ordering",
      "invite-user": {
        "description": "When you create a customer, they will be sent an invite email to set up their account and they will inherit the same settings. If they already have an account on your store, they will be able to log in with their existing credentials.",
        "description-bigcommerce": "When you create a customer, they will need to go to your store's login page and click \"Forgot your password?\" After entering their email address, they will receive an email for them to set up a password. They will be given the same group, sales agent groups, percentage discounts and price lists as you.",
        "form": {
          "cancel": "Cancel",
          "company": "Company",
          "email": "Email",
          "first-name": "First Name",
          "last-name": "Last Name",
          "send-invite": "Add new customer",
          "title": "Invite a new customer"
        },
        "header": "New customer",
        "invite-failed": "Sorry, it looks like we're not able to invite this customer",
        "invite-sent": "Customer invite sent"
      },
      "options-dropdown": {
        "new-customer": "Add a new customer"
      },
      "purchases": {
        "assigned-to-me": "Assigned to me",
        "placed-by-me": "Placed by me",
        "unassigned-quotes": "Unassigned quotes"
      },
      "search": {
        "impersonator-no-recent": "You have no recently accessed accounts.",
        "impersonator-no-recent-message": "You'll see recently accessed accounts once you sign in as a customer above.",
        "impersonator-session-table": {
          "email": "Email",
          "last-login": "Last Login",
          "login": "Login",
          "name": "Name",
          "title": "Recently accessed accounts"
        },
        "initial": "Approved customers will show here once you search.",
        "initial-title": "Manage your customers",
        "none-found": "Sorry, no customers match this search term.",
        "placeholder": "Search for a customer to get started",
        "select-customer": "Select customer"
      }
    }
  },
  "cart": {
    "accept-proceed-to-cart-when-overrides": "I acknowledge that I've made changes to requirements in this order",
    "add-custom-line-item": {
      "btn": "Add",
      "name": "Name",
      "qty": "Quantity",
      "title": "Add custom item"
    },
    "approving-for": {
      "abort": "Back to your order",
      "description": "Once you've made any edits, you can proceed to complete this order.",
      "title": "You are completing this order on behalf of \"{name}\""
    },
    "checkout": {
      "close": "Close & Edit Cart",
      "confirm-btn": {
        "checkout": "Complete Payment: {total}",
        "complete": "Complete Order: {total}",
        "quote": "Request Quote: {total}",
        "submitForApproval": "Submit Order: {total}"
      },
      "coupons": {
        "already-applied": "Discount code ''{couponCode}'' already applied",
        "apply": "Apply",
        "input-placeholder": "Enter discount code here and click 'Apply'",
        "max-reached": "You can only add a maximum of 3 discount codes",
        "not-found": "Discount code ''{couponCode}'' not found",
        "successful-apply": "You've successfully added discount code ''{couponCode}''!"
      },
      "discount": {
        "cta": "View discount or enter code",
        "no-of-discounts-applied": "{numberOf} {numberOf, plural, =1 {discount applied} other {discounts applied}}",
        "success-message": "Your order qualifies for the following discounts",
        "totals-row-text": "Discounts Applied"
      },
      "file-attachment": {
        "choose-file": "Choose file",
        "delete-success": "Successfully deleted {fileName}",
        "upload-failed": {
          "default": "Failed to upload {fileName} ({fileSize}).",
          "file-too-large": "Failed to upload {fileName} ({fileSize}) - too large.",
          "max-files": "Failed to upload {fileName} - maximum number of files reached.",
          "unsupported-file-type": "Failed to upload {fileName} ({fileSize}) - unsupported file type."
        },
        "upload-success": "Successfully uploaded {fileName} ({fileSize}).",
        "uploading": "Uploading..."
      },
      "loading": "Loading...",
      "notes": {
        "default-helper-text": "",
        "helper-text": "Please note, this is required before placing your order",
        "label": "Additional Information",
        "placeholder": "Order notes e.g. PO Number",
        "tax-id-label": "Additional Tax ID",
        "tax-id-placeholder": "Tax ID"
      },
      "payment-button": "Continue",
      "payment-method": {
        "credit-limit-hit": {
          "message": "You can place an order but it may be delayed and subject to approval. If you'd like to discuss your payment terms, please contact us.",
          "title": "Your cart currently exceeds your available credit limit"
        },
        "credit-unavailable": {
          "message": "Please choose an alternative payment method to complete your order. If you'd like to discuss your payment terms, please contact us.",
          "title": "Your cart currently exceeds your available credit limit"
        },
        "full": {
          "paymentByInvoice": "Pay by Invoice",
          "paymentOnAccount": "Pay on Account",
          "quote": "Request for Quote",
          "upfrontPayment": "Pay Online by Card"
        },
        "label": "Payment Method",
        "missing": "No payment methods associated, please contact customer services",
        "mobile": {
          "paymentByInvoice": "Payment: By Invoice",
          "paymentOnAccount": "Payment: On Account",
          "quote": "Request for Quote",
          "upfrontPayment": "Payment: Debit or Credit Card"
        },
        "submitting-quote": {
          "message": "Please select the payment method you intend to use when completing your quote."
        },
        "unavailable": "Unavailable"
      },
      "payment-providers": {
        "paymentByInvoice": {
          "message": ""
        },
        "paymentOnAccount": {
          "message": ""
        },
        "quote": {
          "message": "When requesting a quote for your order, our team will review and notify you within 2 working days before processing."
        },
        "upfrontPayment": {
          "message": ""
        }
      },
      "quote": {
        "communications": {
          "title": "Communications"
        },
        "completing-quote": {
          "abort": "Cancel?",
          "abort-complete-message": "You've cancelled the quote completion",
          "description": "If you're ready to place the order, click \"Complete Order\".",
          "title": "You are completing a quote"
        },
        "discounts-removed": "Discounts are not available for quotes and have been removed",
        "review-message": "The customer will be notified to review the changes made",
        "title": "This order will be submitted as a quote"
      },
      "review-step": {
        "custom-message": ""
      },
      "shipping-address": {
        "edit-address": "Edit an existing address",
        "edit-address-link-title": "your account",
        "edit-address-note": "You can edit existing addresses from ",
        "error": "Please contact us to add an address to continue",
        "error-already-exists": "This address already exists, please use the existing address instead.",
        "error-editing-allowed": "Please add an address to continue",
        "label": "Shipping Address",
        "new-address": "Add a new address",
        "notes": "Address management has been restricted on your account",
        "notes-edit-allowed": "Add or edit your addresses",
        "save-address": "Save address to address book",
        "no-results": "No addresses match your search.",
        "search": "Filter the addresses, by searching...",
        "use-address": "Continue and use this address",
        "no-address": "No saved addresses yet. Add a shipping address to proceed with your order.",
        "add": "Add address"
      },
      "shipping-method": {
        "custom-method": {
          "add": "Add custom rate",
          "delete": "Delete",
          "edit": "Edit custom rate",
          "input": {
            "name-placeholder": "Name"
          },
          "message": "Set a custom shipping rate for this order to replace default shipping methods",
          "new": "Set custom shipping method",
          "save": "Save",
          "update": "Update"
        },
        "label": "Shipping Method",
        "missing": "Sorry, no shipping methods are available for your selected address"
      },
      "steps": {
        "quote-details": "Quote Details",
        "step-four": "Complete",
        "step-one": "My Cart",
        "step-three": "Review & Pay",
        "step-two": "Shipping"
      },
      "test-mode": {
        "title": "Preview mode activated",
        "message": "B2B checkout is in preview mode. Orders will not be fulfilled. If you are a store owner, click \"Launch SparkLayer\" in the {link} to go live.",
        "link": "SparkLayer App"
      },
      "terms": {
        "end": " ",
        "link": "terms and conditions",
        "start": "I agree to the "
      }
    },
    "edit-quote": "Edit Quote",
    "editing-quote": {
      "abort": "Cancel changes?",
      "description": "Once you've made edits, click \"Edit Quote\" to save your changes.",
      "title": "You are editing a quote"
    },
    "empty": "Browse our website to begin adding products, try our search above, or use a shortcut below.",
    "empty-actions": {
      "barcode": {
        "description": "Use your mobile device to add products by barcode",
        "label": "Scan a barcode"
      },
      "email": {
        "description": "Start by emailing your product details",
        "label": "Forward an email"
      },
      "file": {
        "description": "Start by uploading a document (e.g. CSV or PDF)",
        "label": "Upload a file"
      },
      "repeat": {
        "description": "Use a previous order",
        "label": "Repeat order"
      }
    },
    "empty-title": "Let's begin building your order.",
    "header": {
      "company-fallback": "B2B Account",
      "logout": "Log out",
      "title": "My Cart",
      "title-impersonating": "{name}'s Cart",
      "who": "Signed in as {email}."
    },
    "import": {
      "ai": "AI",
      "ai-loading": {
        "description": "We'll do our best to process your {type} but mistakes may happen.",
        "email": "emails",
        "file": "files",
        "title": "We're processing your {type}..."
      },
      "csv-headers": {
        "barcode": "barcode",
        "qty": "qty",
        "sku": "sku"
      },
      "email": {
        "address-message": "This email address is unique to you and can be used for all future orders.",
        "content": "Convert an email into a cart.",
        "copy": "Copy",
        "description": "Forward an email to the address above with quantities and SKUs (or barcodes). We can also process attachments.",
        "error-not-found": "No items found in the email(s)",
        "notification": {
          "message": "You can add these items to your cart.",
          "populate-cart": "Populate cart from email",
          "title": "Email has been received",
          "waiting": "Waiting for an email to be forwarded"
        },
        "security-message": "Your data is secure. When you send an email, no data will be used for training, and all data will be deleted within 24 hours of sending",
        "title": "Forward an email"
      },
      "error-message": "Sorry, we're unable to import the contents you've uploaded. Please ensure the file or contents you are uploading is saved in the correct format (as shown below) and the {uploadType}s you've specified are available on this store.",
      "file": {
        "ai": {
          "description": "Try PDFs, spreadsheets, photos, CSV files... anything you like. We'll automatically detect the contents and add products to your cart.",
          "pill-header": "Upload a file",
          "security-message": "Your data is secure. When uploading files to your order, no data will be used for training, and all data will be deleted within 24 hours of upload.",
          "tip": "For best results, make sure your file has quantities and SKUs or barcodes.",
          "title": "Convert a file into a cart."
        },
        "csv": {
          "pill-header": "Use a CSV template"
        }
      },
      "header": "Import notification: {num} in total",
      "header-success": "Items have been successfully added to your cart!",
      "helper-button": "Upload CSV File",
      "helper-message": "Save time by uploading your cart via a CSV file. Simply create and save the CSV, ensuring it has column titles that match below, and click the 'Upload CSV File' button",
      "helper-paste-button": "Paste & Upload Cart",
      "helper-paste-hover-title": "Paste the contents of your CSV file in here",
      "helper-paste-message": "You can also paste the contents of your CSV file. From your spreadsheet editor, copy the first two columns and paste below",
      "helper-title": "Upload CSV File",
      "like-magic": "Like magic...",
      "messages": {
        "excessive-lines": "Sorry, we're unable to add more items to your cart",
        "not-found": "Product not found",
        "pack-size": "Quantity rounded to the nearest pack size",
        "product-settings-overridden": "Default product settings have been overridden. You can edit these within the cart.",
        "qty-excessive": "Quantity lowered to allowed quantity",
        "qty-insufficient": "Quantity increased to minimum quantity",
        "qty-unavailable": "Quantity has been lowered to available quantity or the product is out of stock",
        "qty-unavailable-no-clamp": "Added to cart, but the requested quantity isn't available. Please view your cart to adjust the quantity.",
        "unavailable": "Unavailable"
      },
      "p": "Your items have been added excluding the following:",
      "p-success": "You can review your cart below before checking out",
      "upload-type": {
        "barcode": "Barcode",
        "sku": "SKU"
      },
      "upload-type-button": "Using a {uploadType}"
    },
    "locking": {
      "message": {
        "action": "Take control",
        "description": "You can either wait for the other user to finish editing or manually take control of the cart.",
        "last-access": "The user last accessed this cart at {lastAccess}.",
        "title": {
          "by-another-user": "This cart is being edited by another user",
          "by-sales-agent": "This cart is being edited by a sales agent"
        }
      }
    },
    "no-of-order-items": "{numberOf} {numberOf, plural, =1 {item} other {items}}",
    "no-of-order-lines": "{numberOf} {numberOf, plural, =1 {line} other {lines}}",
    "options-dropdown": {
      "add-custom-item": "Add custom item",
      "clear-cart": "Clear cart",
      "csv-import": "Upload a file",
      "forward-email": "Forward an email",
      "label": "Options",
      "save-cart-title": "Shopping lists",
      "add-to-list": "Add to shopping list"
    },
    "price": {
      "rrp": "RRP: "
    },
    "price-breaks": {
      "title": "Qty discount pricing"
    },
    "proceed-to-checkout": "Checkout",
    "purchase-history": {
      "message": {
        "create": {
          "placeholder": "Enter a message here (optional)"
        }
      }
    },
    "quick-order": {
      "barcode-not-found": "No barcode found in image",
      "scan-barcode": "Scan barcode",
      "search-placeholder": "Add products by SKU or Barcode"
    },
    "quoted-price": {
      "reset-btn": "Reset",
      "save-btn": "Save",
      "title": "Edit quoted unit price"
    },
    "request-quote": "Request Quote",
    "submit-quote": "Submit Quote",
    "tax-shipping-message": "Tax and shipping costs shown on next step",
    "tax-shipping-note": "Tax and shipping costs calculated during checkout",
    "thanks": {
      "close": "Close",
      "for-approval": {
        "blurb": "We have notified the main user for your company to review your order. You can see the status of this order at any time from your My Account Area.",
        "button": "View Order",
        "main": "Your order has successfully been submitted for review."
      },
      "payment": {
        "blurb": "Your order has now been placed and you will shortly receive email confirmation to {email}. You can check the status of your order at any time by going to 'My Account'.",
        "button": "View Order",
        "main": "Thank you for your order!"
      },
      "quote": {
        "blurb": "We can confirm that your request for a quote has been received and we'll be in touch once our team has reviewed it.",
        "button": "View Quote",
        "main": "Thank you for requesting a quote!"
      }
    },
    "validation-messages": {
      "actions": {
        "remove-item": "Remove item",
        "set-to-available-quantity": "Set to available ({availableQuantity})"
      },
      "items-unavailable": "Sorry, one or more items are now unavailable. Please review and adjust quantity.",
      "limited-stock-available": "Sorry, we only have {qty} of {sku} available right now, please adjust the quantity in your cart before checkout.",
      "maximum-number-files": "Too many files. Maximum is {number}.",
      "maximum-order-item-quantity": "Your cart must not exceed {maximum} items to meet the order requirements.",
      "maximum-order-totals": "Your cart must be less than {amount} to meet the order requirements.",
      "maximum-parent-quantity": "\"{productName}\" has a maximum order quantity of {maximum}.",
      "maximum-variant-quantity": "\"{variantSKU}\" has a maximum order quantity of {maximum}.",
      "minimum-number-files": "Not enough files. Minimum is {number}.",
      "minimum-order-item-quantity": "Your cart must have at least {minimum} items to meet the order requirements.",
      "minimum-order-totals": "Your cart must be more than {amount} to meet the order requirements.",
      "minimum-parent-quantity": "\"{productName}\" has a minimum order quantity of {minimum}.",
      "out-of-stock": "Sorry, {sku} is now unavailable. Please remove this product from your order before checkout.",
      "pack-size": "\"{variantSKU}\" has a pack size of {packSize}.",
      "pricing-unavailable": "{variantSKU} - product is currently unavailable.",
      "pricing-unavailable-for-selected-qty": "{variantSKU} - product unavailable in selected quantity, please adjust quantity.",
      "quantity-unavailable": "{variantSKU} - requested quantity is unavailable.",
      "select-dropdown-option": "Please select an option.",
      "title": "Before you can \"{proceedToCheckout}\", please review the following:",
      "title-complete-order": "Before you can complete this order, the following will need to be resolved:",
      "title-quote": "You can continue with \"{requestQuote}\"."
    },
    "variant-search": {
      "no-results-heading": "Sorry, no results were found for this search term.",
      "placeholder": "Add products by name, SKU, or barcode",
      "results-count": "{count} results.",
      "results-count-full": "Showing {limit} out of {count} results.",
      "results-see-all": "See all results"
    }
  },
  "date": {
    "date-with-time": "{date} at {time}",
    "ordinals": {
      "few": "rd",
      "many": "",
      "one": "st",
      "other": "th",
      "two": "nd",
      "zero": "th"
    }
  },
  "drawer": {
    "button-view": {
      "expand": "Expand",
      "reduce": "Minimise"
    },
    "tabs": {
      "account": "My Account",
      "cart": "My Cart",
      "close": "Close",
      "my-customers": "My Customers"
    }
  },
  "global": {
    "actions": "Actions",
    "view-all": "View all",
    "delete-confirm": "Are you sure you want to delete this address?",
    "errors": {
      "cant-complete-cart-incorrect-tax-information": "Please check tax information",
      "cant-complete-cart-not-allowed": "You cannot complete the cart",
      "cant-edit-cart-locked-by-another-sales-agent": "You cannot update the cart as it is being edited by another sales agent",
      "cant-edit-cart-locked-by-customer": "You cannot update the cart as it is being edited by the customer",
      "cant-edit-cart-locked-by-sales-agent": "You cannot update the cart as it is being edited by a sales agent",
      "cant-edit-cart-not-allowed": "You cannot update the cart",
      "cant-edit-cart-when-completing-quote": "You cannot update the cart when completing a quote",
      "cant-impersonate-customer": "We're unable to access the customer details, please contact the merchant for further help."
    },
    "per-unit": "{price} per unit",
    "product": {
      "barcode": "Barcode: ",
      "sku": "SKU: {sku}"
    },
    "product-settings": {
      "end-user-cant-edit-overridden-qty": "Please speak to your sales agent if you wish to make changes",
      "label": "Qty rules apply",
      "label-overridden": "Qty rules overridden",
      "label-overridden-long": "Default product settings have been overridden",
      "max-order-parent-quantity": "This product has a maximum quantity of {maxOrderParentQuantity} across all variants",
      "max-order-quantity": "Each variant has a maximum order quantity of {maxOrderQuantity}",
      "min-order-parent-quantity": "This product has a minimum quantity of {minOrderParentQuantity} across all variants",
      "min-order-quantity": "Each variant has a minimum order quantity of {minOrderQuantity}",
      "pack-size": "This product comes in pack sizes of {packSize}"
    },
    "rrp-toggle": {
      "label": "Show pricing as RRP",
      "tooltip": "Turn this on to hide B2B prices and show RRP prices only"
    },
    "sales-agent": {
      "sub": "Any actions you take will be made on their behalf.",
      "switch": "Switch Account",
      "title": "You're signed in as { name }"
    },
    "toast": {
      "cart": {
        "excessive-lines": "Sorry, we're unable to add more items to your cart",
        "not-found": "Product not found",
        "pack-size": "Quantity has been rounded down to the nearest pack size",
        "product-settings-overridden": "Default product settings have been overridden. You can edit these within the cart.",
        "qty-excessive": "Quantity has been brought down to the allowed quantity",
        "qty-insufficient": "Quantity has been brought up to the minimum quantity",
        "qty-unavailable": "Quantity has been lowered to the available quantity",
        "qty-unavailable-no-clamp": "Added to cart, but the requested quantity isn't available. Please view your cart to adjust the quantity.",
        "success": "Added to cart",
        "unavailable": "Sorry, this product is unavailable for purchase"
      },
      "copy-to-clipboard": "Successfully copied to clipboard",
      "messaging": {
        "message-sent": "Your message has been sent and saved to the timeline",
        "note-added": "Your note has been saved to the timeline"
      },
      "shopping-lists": {
        "delete": "Shopping list deleted",
        "export": "Shopping list exported as CSV",
        "save": "Shopping list saved",
        "update": "Shopping list updated",
        "view": "View shopping list"
      },
      "system-error": "An unknown error occurred, please try again later",
      "view-cart": "View cart & checkout"
    },
    "totals": {
      "balance": "Balance",
      "net-payment": "Net payment",
      "paid": "Paid",
      "refund-discrepancies": "Refund discrepancies",
      "shipping": "Shipping",
      "sub": "Sub-total",
      "tax": "Tax",
      "total": "Total"
    }
  },
  "login": {
    "errors": {
      "invalid": "Incorrect details, please try again.",
      "system": "An error occurred, please contact us for more details."
    },
    "form": {
      "email": {
        "placeholder": "Enter your email address"
      },
      "password": {
        "placeholder": "Enter your password"
      },
      "sign-in": {
        "btn": "Sign In"
      }
    },
    "register": {
      "text": "You can register an account by clicking here. For access to our wholesale pricing, please get in contact.",
      "title": "Don't have an account yet?"
    },
    "text": "Please sign in below to access your account.",
    "title": "Sign In"
  },
  "pdp": {
    "add-to-order": {
      "cta-text": "Add to Cart ({price})",
      "disabled": "Please select a quantity",
      "loading": "Adding...",
      "text": "Add to Cart"
    },
    "details": "Details",
    "messaging": {
      "back-order": "Pre-order",
      "back-order-due": "Due: {restockDate}",
      "in-stock": "In stock",
      "last-stock": "Last stock",
      "low-stock": "Low stock",
      "out-of-stock": "Out of stock",
      "poa": "POA",
      "un-sellable": "Unavailable",
      "unavailable-items-will-need-to-be-removed": "Please note, unavailable items will need to be removed from your cart before checkout."
    },
    "price": {
      "from": "From: ",
      "from-prefix": " ",
      "from-prefix-rrp": " ",
      "missing": "---",
      "pack-size": "Pack ({packSize}): {price}",
      "rrp": "RRP: ",
      "single-tiered": "{quantity}+",
      "single-uom": "{unitOfMeasure} ({quantity}): {price}"
    },
    "price-breaks": {
      "multi-variant-message": "Qty discount pricing available",
      "multi-variant-message-hover": "Qty discount pricing",
      "multi-variant-percent-save": "Save",
      "multi-variant-summary": "Discounts",
      "price": "Price",
      "qty": "Qty",
      "savings": "Savings"
    },
    "product-code": "Product Code: ",
    "table": {
      "disabled": "Please select a quantity",
      "item": "Item",
      "pack": "Pack",
      "price": "Price",
      "qty": "Qty",
      "stock": "Stock"
    }
  },
  "product-card": {
    "add-to-order": {
      "cta-text": "Add ({price})",
      "loading": "Adding...",
      "text": "Add"
    },
    "messaging": {
      "back-order": "Pre-order",
      "back-order-due": "Due: {restockDate}",
      "in-stock": "In stock",
      "out-of-stock": "Out of stock",
      "select-option": "Unavailable, please select another option",
      "un-sellable": "Unavailable"
    },
    "price": {
      "from": "From: ",
      "missing": "---",
      "rrp": "RRP: "
    },
    "price-breaks": {
      "cheapest": "From {price} for {qty}+",
      "cheapest-unit-of-measure": "From {price} per unit",
      "saving": "(Save {per})",
      "title": "Qty discounts:"
    }
  },
  "reorder": {
    "button-add": "Add items to existing cart",
    "button-clear": "Create new cart",
    "button-title": "Order again"
  },
  "unit-of-measure": {
    "price-breakdown-line": "{quantity} x {unitPrice} ({uomQuantity} {unitType})",
    "price-breakdown-line-single-unit": "{quantity} x {unitPrice}",
    "unit-type": {
      "box": "{uomQuantity, plural, =1 {box} other {boxes}}",
      "case": "{uomQuantity, plural, =1 {case} other {cases}}",
      "crate": "{uomQuantity, plural, =1 {crate} other {crates}}",
      "pallet": "{uomQuantity, plural, =1 {pallet} other {pallets}}"
    },
    "unit-type-and-size": "{unitType}({uomSize})"
  }
}
